import { render, staticRenderFns } from "./extension.vue?vue&type=template&id=0a469ff5&scoped=true"
import script from "./extension.vue?vue&type=script&lang=js"
export * from "./extension.vue?vue&type=script&lang=js"
import style0 from "./extension.vue?vue&type=style&index=0&id=0a469ff5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a469ff5",
  null
  
)

export default component.exports